<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content>
  <p>{{ data.message }}</p>
  @if (data.warningMessage) {
    <p class="warning-message">{{ data.warningMessage }}</p>
  }
  @for (warning of data.warningMessages; track warning) {
    <p class="warning-message">{{ warning }}</p>
  }
</mat-dialog-content>
<mat-dialog-actions>
  @if (data.button1; as button1) {
    @if (button1.focusInitial) {
      <button
        type="button"
        class="btn-1"
        mat-raised-button
        [mat-dialog-close]="button1.result"
        color="{{ button1.matColor ? button1.matColor : '' }}"
        cdkFocusInitial
        >
        @if (button1.icon) {
          <mat-icon fontSet="material-symbols-outlined">{{ button1.icon }}</mat-icon>
        }
        {{ button1.label }}
      </button>
    }
    @if (!button1.focusInitial) {
      <button
        type="button"
        class="btn-1"
        mat-raised-button
        [mat-dialog-close]="button1.result"
        color="{{ button1.matColor ? button1.matColor : '' }}"
        >
        @if (button1.icon) {
          <mat-icon fontSet="material-symbols-outlined">{{ button1.icon }}</mat-icon>
        }
        {{ button1.label }}
      </button>
    }
  }
  @if (data.button2; as button2) {
    @if (button2.focusInitial) {
      <button
        type="button"
        class="btn-2"
        mat-raised-button
        [mat-dialog-close]="button2.result"
        color="{{ button2.matColor ? button2.matColor : '' }}"
        cdkFocusInitial
        >
        @if (button2.icon) {
          <mat-icon fontSet="material-symbols-outlined">{{ button2.icon }}</mat-icon>
        }
        {{ button2.label }}
      </button>
    }
    @if (!button2.focusInitial) {
      <button
        type="button"
        class="btn-2"
        mat-raised-button
        [mat-dialog-close]="button2.result"
        color="{{ button2.matColor ? button2.matColor : '' }}"
        >
        @if (button2.icon) {
          <mat-icon fontSet="material-symbols-outlined">{{ button2.icon }}</mat-icon>
        }
        {{ button2.label }}
      </button>
    }
  }
</mat-dialog-actions>
